import React from 'react';
import TextField from '@material-ui/core/TextField';
import { InputAdornment } from '@material-ui/core';
import SendIcon from '@material-ui/icons/Send';
import _IconButton from '@material-ui/core/IconButton';
import styled from 'styled-components/macro';

const ContainerDiv = styled.div`
  && {
    margin-top: 1rem;
  }
`;
const IconButton = styled(_IconButton)`
  && {
    padding: 0;
  }
`;

const AddTaskCommentView = props => {
  return (
    <ContainerDiv>
      <TextField
        data-testid={'comment-field'}
        multiline
        fullWidth
        maxRows={4}
        variant="outlined"
        placeholder="Add a comment..."
        value={props.comment}
        onChange={e => props.setComment(e.target.value)}
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <IconButton
                size="small"
                disabled={!props.comment || !props.comment.trim()}
                onClick={props.clickedSend}
              >
                <SendIcon />
              </IconButton>
            </InputAdornment>
          )
        }}
      />
    </ContainerDiv>
  );
};

export default AddTaskCommentView;
